/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Evgeny Sapozhnikov <evgeny.sapozhnikov@opensoftdev.ru>
 */
import 'APP_THEME/_common/base/index';

import 'APP_THEME/_common/featured_header/index.less';
import 'resources/less/themes/base/pages/start_shop_by.less';
import 'resources/less/themes/base/widgets/standalone/reviews.less';
import 'resources/less/themes/base/pages/standalone/all_products.less';
import 'resources/less/themes/base/widgets/featured_product_blocks.less';
import 'APP_THEME/_common/main_banner/index.less';
import 'resources/less/themes/base/widgets/breadcrumbs.less';
import 'resources/less/themes/base/elements/simplified/button_large.less';

import 'assets/js/start/pricingLoader';
import 'assets/js/slider';
import screen from 'assets/js/modules/screen';

$('.clickable-banner').on('click', function() {
    window.location = $(this)
        .find('.main-banner a')
        .attr('href');
});

$('.featured-product-blocks').on('click', '.featured-product-block', function() {
    var link = $(this)
        .find('.featured-product-link')
        .attr('href');
    if (link) {
        window.location.href = link;
    }
});

function initSliderAction() {
    if (screen.isBig()) {
        $('.featured-products-slider').each(function(index, el) {
            $($(el).find('.featured-product-blocks')).sliderAction({
                listParent: $(el).find('.featured-products-trimmer'),
                listClass: '.featured-product-container',
                next: $(el).find('.next'),
                prev: $(el).find('.prev')
            });
        });
    } else {
        $('.featured-products-slider').each(function(index, el) {
            $($(el).find('.featured-product-blocks')).removeAttr('style');
        });
    }
}

$(window).resize(function() {
    initSliderAction();
});

initSliderAction();
